import React, { useEffect, useReducer } from 'react'
import { connect } from 'react-redux'
import {
  Badge,
  BtnIcon,
  CustomCard,
  Loading,
  NumeroDecimal,
  PageHeader,
  Periodo,
  SectionHeader,
  SelectEmpresas,
} from '../../../../components'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FaRegFileExcel } from 'react-icons/fa'
import { azul_escuro, error, pink } from '../../../../assets/js/colors'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import {
  getPeriodoMesAtual,
  parseToMysqlFormatWithTime,
} from '../../../../services/util/date.service'
import { getInfoForAnaliseDasOcorrenciasPanel } from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { useAnaliseOcorrenciaContext } from '../../../../contexts/OrdemColetaContext'

const { dataInicial, dataFinal } = getPeriodoMesAtual()

const initState = {
  selectedEmpresa: '',
  ocorrenciasAnaliticas: [],
  pickings: [],
  cardPercentualOcorrencias: {
    total_caixas: '',
    total_ocorrencias: '',
    percentual_ocorrencias: '',
  },
  etapaOcorrenciaData: [],
  tipoOcorrenciaData: [],
  qteOcorrenciasPorTp: [],
  qteEntregasPendentes: [],
  pInicial: dataInicial,
  pFinal: dataFinal,
  isLoading: false,
}

const ON_EMPRESA_CHANGE = 'ON_EMPRESA_CHANGE'
const ON_PESQUISAR = 'ON_PESQUISAR'
const ON_DATA_FETCHED = 'ON_DATA_FETCHED'
const ON_PERIODO_CHANGE = 'ON_PERIODO_CHANGE'
const IS_LOADING = 'IS_LOADING'

const reducer = (state, { type, payload }) => {
  switch (type) {
    case ON_EMPRESA_CHANGE:
      return { ...state, selectedEmpresa: payload.empresaId }
    case ON_PESQUISAR:
      return { ...state }
    case ON_PERIODO_CHANGE:
      return { ...state, pInicial: payload.pInicial, pFinal: payload.pFinal }
    case ON_DATA_FETCHED:
      return {
        ...state,
        ocorrenciasAnaliticas: payload.ocorrenciasAnaliticas,
        pickings: payload.pickings,
        cardPercentualOcorrencias: payload.cardPercentualOcorrencias,
        etapaOcorrenciaData: payload.etapaOcorrenciaData,
        tipoOcorrenciaData: payload.tipoOcorrenciaData,
        qteOcorrenciasPorTp: payload.qteOcorrenciasPorTp,
        qteEntregasPendentes: payload.qteEntregasPendentes,
        isLoading: false,
      }
    case IS_LOADING:
      return { ...state, isLoading: payload }
    default:
      return state
  }
}

function AnaliseDasOcorrencias({ dispatch, selectedTp }) {
  const context = useAnaliseOcorrenciaContext()

  // Hooks
  const [state, localDispatch] = useReducer(reducer, {
    ...initState,
    pInicial: context.analiseOcorrenciaContext.selectedPeriodo.dataInicial,
    pFinal: context.analiseOcorrenciaContext.selectedPeriodo.dataFinal,
    selectedEmpresa: context.analiseOcorrenciaContext.selectedEmpresa,
  })

  // Events
  const fetchAnaliseOcorrenciaData = (pInicial, pFinal) => {
    localDispatch({ type: IS_LOADING, payload: true })
    const { selectedEmpresa } = state
    const { id: user_id } = getUsuarioInfo()

    getInfoForAnaliseDasOcorrenciasPanel(
      user_id,
      selectedTp,
      selectedEmpresa,
      parseToMysqlFormatWithTime(pInicial),
      parseToMysqlFormatWithTime(pFinal),
    )
      .then(data => {
        context.setAnaliseOcorrenciaContext(prevAnaliseOcorrenciaContext => ({
          ...prevAnaliseOcorrenciaContext,
          data: data,
        }))
        localDispatch({ type: ON_DATA_FETCHED, payload: data })
      })
      .catch(error => {
        localDispatch({ type: IS_LOADING, payload: false })
        dispatch(showMessageBox(null, errorHandler(error)))
      })
  }

  const onBtnPesquisarClick = (pInicial, pFinal) => {
    context.setAnaliseOcorrenciaContext(prevAnaliseOcorrenciaContext => ({
      ...prevAnaliseOcorrenciaContext,
      selectedPeriodo: { dataInicial: pInicial, dataFinal: pFinal },
    }))
    if (state.selectedEmpresa === '') {
      dispatch(showMessageBox(null, 'Selecione a Empresa Desejada'))
    } else {
      fetchAnaliseOcorrenciaData(pInicial, pFinal)
    }
  }
  // Helpers
  useEffect(() => {
    if (
      context.analiseOcorrenciaContext.selectedEmpresa !== '' &&
      context.analiseOcorrenciaContext.data !== ''
    ) {
      localDispatch({ type: ON_DATA_FETCHED, payload: context.analiseOcorrenciaContext.data })
    }
  }, [])

  // Renders
  return (
    <React.Fragment>
      <PageHeader>Análise das Ocorrências</PageHeader>
      <div className="p-grid">
        <div className="p-col-3">
          <SelectEmpresas
            companyId={state.selectedEmpresa}
            onChange={empresa => {
              context.setAnaliseOcorrenciaContext(prevAnaliseOcorrenciaContext => ({
                ...prevAnaliseOcorrenciaContext,
                selectedEmpresa: empresa.id,
              }))
              localDispatch({ type: ON_EMPRESA_CHANGE, payload: { empresaId: empresa.id } })
            }}
          />
        </div>
        <div className="p-col-4">
          <Periodo
            periodoInicial={state.pInicial}
            periodoFinal={state.pFinal}
            onPesquisar={onBtnPesquisarClick}
          />
        </div>
        <div className="p-col-4 text-left" style={{ paddingTop: 25 }}>
          {state.isLoading ? <Loading /> : null}
        </div>
      </div>
      <div className="p-grid" style={{ marginTop: 20 }}>
        <div className="p-col-3">
          {state.cardPercentualOcorrencias.percentual_ocorrencias === '' ? null : (
            <PercentualOcorrencia cardPercentualOcorrencias={state.cardPercentualOcorrencias} />
          )}
        </div>
        <div className="p-col-6">
          {state.tipoOcorrenciaData.length === 0 ? null : (
            <GraficoTipoOcorrencia tipoOcorrenciaData={state.tipoOcorrenciaData} />
          )}
        </div>
        <div className="p-col-3">
          {state.etapaOcorrenciaData.length === 0 ? null : (
            <GraficoEtapaOcorrencia etapaOcorrenciaData={state.etapaOcorrenciaData} />
          )}
        </div>
        <div className="p-col-6">
          <OcorrenciasPorTp qteOcorrenciasPorTp={state.qteOcorrenciasPorTp} />
        </div>
        <div className="p-col-6">
          <EntregasPendentesPorTp qteEntregasPendentes={state.qteEntregasPendentes} />
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <OcorrenciasAnaliticas ocorrenciasAnaliticas={state.ocorrenciasAnaliticas} />
      </div>
      <div style={{ marginTop: 20 }}>
        <StatusPicking pickinks={state.pickings} />
      </div>
    </React.Fragment>
  )
}

function PercentualOcorrencia({ cardPercentualOcorrencias }) {
  // Vars
  const { total_caixas, total_ocorrencias, percentual_ocorrencias } = cardPercentualOcorrencias
  // Render
  return (
    <CustomCard title="% de Ocorrências">
      <div className="p-grid" style={{ textAlign: 'start', fontSize: '0.8rem' }}>
        <div className="p-col-8">Total de Caixas:</div>
        <div className="p-col-4">{total_caixas}</div>
        <div className="p-col-8">Total de Ocorrências:</div>
        <div className="p-col-4">{total_ocorrencias}</div>
        <div
          className="p-col-12"
          style={{ textAlign: 'center', fontSize: '2rem', color: error, fontWeight: 700 }}
        >
          {percentual_ocorrencias}
        </div>
      </div>
    </CustomCard>
  )
}

function OcorrenciasAnaliticas({ ocorrenciasAnaliticas }) {
  // Events
  const onBtnExcelClick = () => {
    const ocorrenciasExcel = [
      [
        'TP',
        'Data_Emissao',
        'Viagem',
        'Embarque',
        'Codigo',
        'Produto',
        'Ocorrencia',
        'Quantidade',
        'Etapa',
      ],
    ]
    ocorrenciasAnaliticas.forEach(o => {
      const cells = []
      cells.push(o.tp)
      cells.push(o.data_emissao)
      cells.push(o.ciclo)
      cells.push(o.identifier)
      cells.push(o.product_code)
      cells.push(o.product_name)
      cells.push(o.ocorrencia)
      cells.push(o.quantidade)
      cells.push(o.stage)
      ocorrenciasExcel.push(cells)
    })
    gerarArquivoExcel('ocorrencias', ocorrenciasExcel, 'ocorrencias.xlsx')
  }
  // Render
  return (
    <React.Fragment>
      <SectionHeader>Ocorrências Analíticas</SectionHeader>
      <div style={{ marginTop: 5 }}>
        <BtnIcon onClick={onBtnExcelClick}>
          <FaRegFileExcel size={18} color={azul_escuro} />
        </BtnIcon>
      </div>
      <div style={{ marginTop: 5 }}>
        <DataTable
          emptyMessage="Nenhuma Ocorrência Apurada"
          value={ocorrenciasAnaliticas}
          paginator={true}
          rows={10}
        >
          <Column field="tp" header="Operador" headerStyle={{ fontWeight: 300 }} />
          <Column field="data_emissao" header="Dt. Emissão" headerStyle={{ fontWeight: 300 }} />
          <Column field="ciclo" header="Picking de Entrega" headerStyle={{ fontWeight: 300 }} />
          <Column field="identifier" header="Identificador" headerStyle={{ fontWeight: 300 }} />
          <Column field="product_code" header="Código" headerStyle={{ fontWeight: 300 }} />
          <Column field="product_name" header="Produto" headerStyle={{ fontWeight: 300 }} />
          <Column
            field="product_weight"
            header="Peso Produto (KG)"
            headerStyle={{ fontWeight: 300 }}
            body={item => <NumeroDecimal>{item.product_weight}</NumeroDecimal>}
          />
          <Column field="pickingarea" header="Área" headerStyle={{ fontWeight: 300 }} />
          <Column field="area_nickname" header="Apelido Área" headerStyle={{ fontWeight: 300 }} />
          <Column field="ocorrencia" header="Ocorrência" headerStyle={{ fontWeight: 300 }} />
          <Column
            field="quantidade"
            header="Quantidade"
            headerStyle={{ fontWeight: 300 }}
            style={{ textAlign: 'center' }}
          />
          <Column field="stage" header="Etapa" headerStyle={{ fontWeight: 300 }} />
        </DataTable>
      </div>
    </React.Fragment>
  )
}

function OcorrenciasPorTp({ qteOcorrenciasPorTp }) {
  return (
    <React.Fragment>
      <SectionHeader>Ocorrências Por Operador</SectionHeader>
      <div style={{ marginTop: 15 }}>
        <DataTable emptyMessage="Nenhuma Ocorrência" value={qteOcorrenciasPorTp}>
          <Column field="tp" header="Operador" headerStyle={{ fontWeight: 300 }} />
          <Column
            field="total_caixas"
            header="Qte Caixas"
            headerStyle={{ fontWeight: 300 }}
            bodyStyle={{ textAlign: 'center' }}
          />
          <Column
            field="total_ocorrencias"
            header="Qte Ocorrência"
            headerStyle={{ fontWeight: 300 }}
            bodyStyle={{ textAlign: 'center' }}
          />
          <Column
            field="percentual_ocorrencias"
            header="% Ocorrência"
            headerStyle={{ fontWeight: 300 }}
            bodyStyle={{ textAlign: 'center' }}
          />
        </DataTable>
      </div>
    </React.Fragment>
  )
}

function EntregasPendentesPorTp({ qteEntregasPendentes }) {
  return (
    <React.Fragment>
      <SectionHeader>Qte. Entregas Pendentes Por Operador</SectionHeader>
      <div style={{ marginTop: 15 }}>
        <DataTable emptyMessage="Nenhuma Ocorrência" value={qteEntregasPendentes}>
          <Column field="tp" header="Operador" headerStyle={{ fontWeight: 300 }} />
          <Column
            field="qte_entregas_pendentes"
            header="Qte Entregas Pendentes"
            headerStyle={{ fontWeight: 300 }}
            bodyStyle={{ textAlign: 'center' }}
          />
        </DataTable>
      </div>
    </React.Fragment>
  )
}

function GraficoTipoOcorrencia({ tipoOcorrenciaData }) {
  const COLORS = [
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
  ]
  return (
    <CustomCard title="Por Tipos de Ocorrência">
      <div style={{ height: 130 }}>
        <ResponsiveContainer height={150} width="100%">
          <PieChart>
            <Pie data={tipoOcorrenciaData} innerRadius={40} outerRadius={60} paddingAngle={5}>
              {tipoOcorrenciaData.map((entry, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Legend verticalAlign="center" layout="vertical" align="right" height={36} />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </CustomCard>
  )
}

function GraficoEtapaOcorrencia({ etapaOcorrenciaData }) {
  const COLORS = ['#FFBB28', '#FF8042']
  return (
    <CustomCard title="Por Etapa">
      <div style={{ height: 130 }}>
        <ResponsiveContainer height={150} width="100%">
          <PieChart>
            <Pie data={etapaOcorrenciaData} outerRadius={60}>
              {etapaOcorrenciaData.map((entry, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Legend verticalAlign="center" layout="vertical" align="right" height={36} />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </CustomCard>
  )
}

function StatusPicking({ pickinks }) {
  // Events
  const onBtnExcelClick = () => {
    const pickinksExcel = [['Data Cadastro', 'TP', 'Desc. Picking', 'Qte Total Caixas', 'Status']]
    pickinks.forEach(p => {
      const cells = []
      cells.push(p.data_cadastro)
      cells.push(p.tp)
      cells.push(p.picking)
      cells.push(p.qte)
      cells.push(p.status)
      pickinksExcel.push(cells)
    })
    gerarArquivoExcel('separacoes', pickinksExcel, 'pickings_pendentes.xlsx')
  }

  // Render
  return (
    <div>
      <SectionHeader>Status das Separações Pendentes</SectionHeader>
      <div style={{ marginTop: 5 }}>
        <BtnIcon onClick={onBtnExcelClick}>
          <FaRegFileExcel size={18} color={azul_escuro} />
        </BtnIcon>
      </div>
      <div style={{ marginTop: 5 }}>
        <DataTable
          emptyMessage="Nenhuma Separação Pendente"
          value={pickinks}
          paginator={true}
          rows={20}
        >
          <Column field="data_cadastro" header="Dt. Cadastro" headerStyle={{ fontWeight: 300 }} />
          <Column field="tp" header="Operador" headerStyle={{ fontWeight: 300 }} />
          <Column field="picking" header="Separação" headerStyle={{ fontWeight: 300 }} />
          <Column field="qte" header="Qte. Itens" headerStyle={{ fontWeight: 300 }} />
          <Column
            field="status"
            header="Status"
            headerStyle={{ fontWeight: 300 }}
            body={picking => {
              switch (picking.status) {
                case 'Pronto Para Download':
                  return <Badge color="#000000">{picking.status}</Badge>
                case 'Concluido Parcialmente':
                  return <Badge color={pink}>{picking.status}</Badge>
                default:
                  return null
              }
            }}
          />
        </DataTable>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(AnaliseDasOcorrencias)
